class FeatureToggle {
  static FEATURES = {
    PORTFOLIO: 'PORTFOLIO',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PENDO: 'PENDO'
  };

  static isFeatureEnabled(key: string) {
    const value = process.env[`REACT_APP_FEATURE_${key}_ENABLE`];
    return value === 'true';
  }
}

export default FeatureToggle;
